import React from "react";

export const TextBox = ({ title, description }) => {
  return (
    <div className="flex flex-col gap-1 lg:gap-5">
      {title && (
        <h2 className="text-primary-500 text-text-lg font-bold lg:font-display lg:text-display-sm">
          {title}
        </h2>
      )}
      {description && <p className="text-text-black text-text-md">{description}</p>}
    </div>
  );
};
